// Cart Billing Info component
// Handles saving billing info fields (ico, dic, firma) to cart attributes
class CartBillingInfo extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.closest('cart-note-dialog');
    this.saveButton = this.querySelector('dialog-close-button button');
    
    if (this.saveButton) {
      this.saveButton.addEventListener('click', this.handleSave.bind(this));
    }
  }

  async handleSave(event) {
    // Prevent the default button behavior temporarily
    event.preventDefault();
    
    // Show loading state
    const originalText = this.saveButton.textContent;
    this.saveButton.disabled = true;
    this.saveButton.textContent = 'Saving...';
    
    // Collect values from the three billing info fields
    const icoInput = this.querySelector('input[name="attributes[ico]"]');
    const dicInput = this.querySelector('input[name="attributes[dic]"]');
    const firmaInput = this.querySelector('input[name="attributes[firma]"]');
    
    const attributes = {};
    
    // Add values to attributes object (empty string for empty fields to clear them)
    if (icoInput) {
      attributes.ico = icoInput.value.trim() || '';
    }
    if (dicInput) {
      attributes.dic = dicInput.value.trim() || '';
    }
    if (firmaInput) {
      attributes.firma = firmaInput.value.trim() || '';
    }

    try {
      // Send the cart update request with attributes
      const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ attributes }),
        keepalive: true
      });

      if (response.ok) {
        // Close the dialog after successful save
        if (this.dialog) {
          this.dialog.hide();
        }
      } else {
        console.error('Failed to save billing info:', response.statusText);
        // Still close the dialog even if there was an error
        if (this.dialog) {
          this.dialog.hide();
        }
      }
    } catch (error) {
      console.error('Error saving billing info:', error);
      // Still close the dialog even if there was an error
      if (this.dialog) {
        this.dialog.hide();
      }
    } finally {
      // Restore button state
      this.saveButton.disabled = false;
      this.saveButton.textContent = originalText;
    }
  }
}

// Register the custom element
if (!window.customElements.get('cart-billing-info')) {
  window.customElements.define('cart-billing-info', CartBillingInfo);
}
